module.exports = __webpack_public_path__ + "img/logo-galeria-pomorska.7cbc2c2a.png";